import { usedCarsAPI, DEALER_MICRO_SITE } from "@/api";
import router from "@/router";
import { GET_DEALER_MICRO_SITE } from "@/store/actionTypes";
import {
  UPDATE_DEALERS_LOCATIONS,
  UPDATE_IS_DEALER_MICRO_SITE,
  UPDATE_DEALER_NAME
} from "@/store/mutationTypes";

export default {
  async [GET_DEALER_MICRO_SITE]({ commit }) {
    if (
      !(
        router.currentRoute.name === "dealerSearch" ||
        router.currentRoute.name === "dealerResults" ||
        router.currentRoute.name === "dealerDetails"
      )
    ) {
      return await commit(UPDATE_IS_DEALER_MICRO_SITE, false);
    }

    try {
      const response = await usedCarsAPI().get(
        DEALER_MICRO_SITE(router.currentRoute.params.dealerName)
      );

      await commit(UPDATE_DEALERS_LOCATIONS, [response.data.pk]);
      await commit(UPDATE_IS_DEALER_MICRO_SITE, true);
      await commit(UPDATE_DEALER_NAME, response.data.name);
    } catch {
      await commit(UPDATE_IS_DEALER_MICRO_SITE, false);
      return router.push("/not-found");
    }
  }
};
